import {
  cibCircleci,
  cibMarketo,
  cibSellfy,
  cibStadia,
  cibWhenIWork,
  cilBook,
  cilBuilding,
  cilCircle,
  cilCommand,
  cilContact,
  cilFax,
  cilFile,
  cilGlobeAlt,
  cilGroup,
  cilHeader,
  cilHome,
  cilNewspaper,
  cilSpeedometer,
  cilUser,
  cilCreditCard,
  cibAddthis,
  cibQualcomm,
  cilReportSlash,
  cilPaperPlane,
  cilTrash,
  cilCarAlt,
  cilBike,
  cilFlightTakeoff,
  cilBadge,
  cilApps,
  cilPeople,
} from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { CNavGroup, CNavItem } from "@coreui/react";
import React from "react";

const nav = [
  {
    component: CNavItem,
    name: "Dashboard",
    to: "/admin/dashboard",
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: "Form Data",
    to: "/admin/formdata",
    icon: <CIcon icon={cilFile} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Contact Form",
        // name: "Contacthome",
        // to: "/admin/formdata/buy",
        to: "/admin/formdata/contactform",
        icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      },
      // {
      //   component: CNavItem,
      //   name: "About Health Form",
      //   // name: "Contacthome",
      //   // to: "/admin/formdata/buy",
      //   to: "/admin/formdata/abouthealth",
      //   icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      // },
      {
        component: CNavItem,
        name: "Claim Form",
        // name: "Contacthome",
        // to: "/admin/formdata/buy",
        to: "/admin/formdata/claimform",
        icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      },
      // {
      //   component: CNavItem,
      //   name: "Sell",
      //   to: "/admin/formdata/sell",
      //   icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      // },
      {
        component: CNavItem,
        name: "Health Form",
        to: "/admin/formdata/healthform",
        icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Two wheeler",
        to: "/admin/formdata/twowheeler",
        icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Four wheeler",
        to: "/admin/formdata/fourwheeler",
        icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Term Form",
        to: "/admin/formdata/term",
        icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Travel Form",
        to: "/admin/formdata/travel",
        icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      },
      // {
      //   component: CNavGroup,
      //   name: "Inquiries",
      //   to: "/admin/formdata/inquiry",
      //   icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      //   items: [
      //     {
      //       component: CNavItem,
      //       name: "User Inquiries",
      //       to: "/admin/formdata/user-inquiry",
      //       icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      //     },
      //     // {
      //     //   component: CNavItem,
      //     //   name: "CP Inquiries",
      //     //   to: "/admin/formdata/cp-inquiry",
      //     //   icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      //     // },
      //   ],
      // },
      // {
      //   component: CNavItem,
      //   name: "Partner",
      //   to: "/admin/formdata/partner",
      //   icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      // },
      // {
      //   component: CNavItem,
      //   name: "Job Application",
      //   to: "/admin/formdata/job-application",
      //   icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      // },
      // {
      //   component: CNavItem,
      //   name: "NewsLetter",
      //   to: "/admin/formdata/newsletter",
      //   icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      // },
    ],
  },
  // {
  //   component: CNavGroup,
  //   name: "About Us",
  //   to: "/admin/aboutus",
  //   icon: <CIcon icon={cilFile} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: "About Health",
  //       // name: "Contacthome",
  //       // to: "/admin/formdata/buy",
  //       to: "/admin/aboutus/abouthealthform",
  //       icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
  //     },
  //   ],
  // },
  // {
  //   component: CNavGroup,
  //   name: "Equity And Real Estate",
  //   to: "/admin/equity-crowdfunding",
  //   icon: <CIcon icon={cilBuilding} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: "Equity",
  //       to: "/admin/equity-crowdfunding/equities",
  //       icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Real Estate",
  //       to: "/admin/equity-crowdfunding/real-estate",
  //       icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
  //     },
  //   ],
  // },
  // {
  //   component: CNavItem,
  //   name: "DRHP Filed Companies",
  //   to: "/admin/upcoming-ipos",
  //   icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
  // },
  {
    component: CNavItem,
    name: "Blog",
    to: "/admin/blog",
    icon: <CIcon icon={cilBook} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Error Page",
    to: "/admin/formdata/errorpage",
    icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Staff",
    to: "/admin/staff",
    icon: <CIcon icon={cibStadia} customClassName="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: "User Management",
    to: "/admin/userlist",
    icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "User",
        to: "/admin/userlist",
        icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
      },
      // {
      //   component: CNavItem,
      //   name: "Kyc",
      //   to: "/admin/kyc",
      //   icon: <CIcon icon={cibWhenIWork} customClassName="nav-icon" />,
      // },
      {
        component: CNavItem,
        name: "Otp",
        to: "/admin/otplist",
        icon: <CIcon icon={cibWhenIWork} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Delete User Request",
        to: "/admin/deleteuser",
        icon: <CIcon icon={cilTrash} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Associate Partners",
        to: "/admin/associatepartners",
        icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
      },
    ],
  },
  // {
  //   component: CNavGroup,
  //   name: "Cp Management",
  //   to: "/admin/cplist",
  //   icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: "Cp List",
  //       to: "/admin/cplist",
  //       icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
  //     },
  //     // {
  //     //   component: CNavItem,
  //     //   name: "Cp Support",
  //     //   to: "/admin/cpsupport",
  //     //   icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
  //     // },
  //     {
  //       component: CNavItem,
  //       name: "Cp Kyc",
  //       to: "/admin/cpkyc",
  //       icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
  //     },
  //   ],
  // },
  // {
  //   component: CNavGroup,
  //   name: "Chart Management",
  //   to: "/admin/chartlist",
  //   icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: "Chart List",
  //       to: "/admin/chartlist",
  //       icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
  //     },
  //     // {
  //     //   component: CNavItem,
  //     //   name: "Cp Support",
  //     //   to: "/admin/cpsupport",
  //     //   icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
  //     // },
  //     // {
  //     //   component: CNavItem,
  //     //   name: "Cp Kyc",
  //     //   to: "/admin/cpkyc",
  //     //   icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
  //     // },
  //   ],
  // },
  {
    component: CNavGroup,
    name: "Transactions",
    to: "/admin/transactions",
    icon: <CIcon icon={cilCreditCard} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Two Wheeler",
        to: "/admin/two-wheeler",
        icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
      },

      {
        component: CNavItem,
        name: "Four Wheeler",
        to: "/admin/four-wheeler",
        icon: <CIcon icon={cibWhenIWork} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Health",
        to: "/admin/health",
        icon: <CIcon icon={cibWhenIWork} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Travel",
        to: "/admin/travel",
        icon: <CIcon icon={cibWhenIWork} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Terms",
        to: "/admin/terms",
        icon: <CIcon icon={cibWhenIWork} customClassName="nav-icon" />,
      },
      // {
      //   component: CNavItem,
      //   name: "Return",
      //   to: "/admin/return",
      //   icon: <CIcon icon={cibWhenIWork} customClassName="nav-icon" />,
      // },
    ],
  },
  {
    component: CNavGroup,
    name: "Quotation",
    to: "/admin/quotation",
    icon: <CIcon icon={cilCreditCard} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "quotation",
        to: "/admin/quotation",
        icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
      },
    ],
  },
  // {
  //   component: CNavGroup,
  //   name: "About US Health",
  //   to: "/admin/health",
  //   icon: <CIcon icon={cilFile} customClassName="nav-icon" />,
  //   items: [
  //     {
  //       component: CNavItem,
  //       name: "Plan Detail",
  //       to: "/admin/aboutushealthform",
  //       icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Add On Coverages",
  //       to: "/admin/aboutushealthaddcoverages",
  //       icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
  //     },
  //     {
  //       component: CNavItem,
  //       name: "Claim Process",
  //       to: "/admin/aboutushealthclaim",
  //       icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
  //     },
  //     {
  //       component: CNavItem,
  //       name: "About Company",
  //       to: "/admin/aboutushealthcompany",
  //       icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
  //     },
  //   ],
  // },
  {
    component: CNavGroup,
    name: "Category and Plans",
    to: "/admin/categoryandplans",
    icon: <CIcon icon={cilFile} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Category And Plans",
        to: "/admin/categoryandplans",
        icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Add-ons",
        to: "/admin/addons",
        icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      },
      // {
      //   component: CNavItem,
      //   name: "Plan-Details",
      //   to: "/admin/plandetails",
      //   icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
      // },
    ],
  },
  {
    component: CNavItem,
    name: "Cashless Hospitals",
    to: "/admin/aboutushealthhospitals",
    icon: <CIcon icon={cilCircle} customClassName="nav-icon" />,
  },
  // {
  //   component: CNavGroup,
  //   name: "Manage API",
  //   to: "/admin/manageapi",
  //   icon: <CIcon icon={cilFile} customClassName="nav-icon" />,
  //   items: [
  //   ],
  // },

  {
    component: CNavItem,
    name: "Manage API",
    to: "/admin/manageapi",
    icon: <CIcon icon={cilApps} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: "Vehicle Lookup",
    to: "/admin/vehiclelookup",
    icon: <CIcon icon={cilCarAlt} customClassName="nav-icon" />,
  },
  {
    component: CNavGroup,
    name: "Header",
    to: "/admin/cplist",
    icon: <CIcon icon={cilHeader} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Global Script Title",
        to: "/admin/header/globalScriptTitle",
        icon: <CIcon icon={cilGlobeAlt} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Home",
        to: "/admin/header/home",
        icon: <CIcon icon={cilGlobeAlt} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Term Life Insurance",
        to: "/admin/header/term-life-insurance",
        icon: <CIcon icon={cilHome} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Health Insurance",
        to: "/admin/header/health Insurance",
        icon: <CIcon icon={cibCircleci} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Family Health Insurance",
        to: "/admin/header/family Health Insurance",
        icon: <CIcon icon={cibWhenIWork} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Group Health Insurance",
        to: "/admin/header/group Health Insurance",
        icon: <CIcon icon={cibMarketo} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Car Insurance",
        to: "/admin/header/Car Insurance",
        icon: <CIcon icon={cilCarAlt} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Two Wheeler Insurance",
        to: "/admin/header/Two Wheeler Insurance",
        icon: <CIcon icon={cilBike} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Travel Insurance",
        to: "/admin/header/Travel Insurance",
        icon: <CIcon icon={cilFlightTakeoff} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Home Insurance",
        to: "/admin/header/Home Insurance",
        icon: <CIcon icon={cilBuilding} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Retirement Plans",
        to: "/admin/header/Retirement Plans",
        icon: <CIcon icon={cilFax} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Investment Plans",
        to: "/admin/header/Investment Plans",
        icon: <CIcon icon={cilBadge} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Guaranteed Return Plans",
        to: "/admin/header/Guaranteed Return Plans",
        icon: <CIcon icon={cilFax} customClassName="nav-icon" />,
      },
      // {
      //   component: CNavItem,
      //   name: "Indian Companies",
      //   to: "/admin/header/IndianCompany",
      //   icon: <CIcon icon={cilCommand} customClassName="nav-icon" />,
      // },
      // {
      //   component: CNavItem,
      //   name: "International Companies",
      //   to: "/admin/header/InternationalCompany",
      //   icon: <CIcon icon={cibIntercom} customClassName="nav-icon" />,
      // },
      // {
      //   component: CNavItem,
      //   name: "Sell",
      //   to: "/admin/header/sell",
      //   icon: <CIcon icon={cibSellfy} customClassName="nav-icon" />,
      // },
      // {
      //   component: CNavItem,
      //   name: "Upcoming IPOs",
      //   to: "/admin/header/ipo",
      //   icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
      // },
      // {
      //   component: CNavItem,
      //   name: "Contact Us",
      //   to: "/admin/header/contactUs",
      //   icon: <CIcon icon={cilContact} customClassName="nav-icon" />,
      // },

      // {
      //   component: CNavItem,
      //   name: "In The News",
      //   to: "/admin/header/inTheNews",
      //   icon: <CIcon icon={cilNewspaper} customClassName="nav-icon" />,
      // },
      // {
      //   component: CNavItem,
      //   name: "Be Our Partner",
      //   to: "/admin/header/beOurPartner",
      //   icon: <CIcon icon={cibPalantir} customClassName="nav-icon" />,
      // },
      // {
      //   component: CNavItem,
      //   name: "Career",
      //   to: "/admin/header/career",
      //   icon: <CIcon icon={cibWhenIWork} customClassName="nav-icon" />,
      // },
      // {
      //   component: CNavItem,
      //   name: "",
      //   to: "/admin/header/",
      //   icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
      // },
    ],
  },
  // {
  //   component: CNavItem,
  //   name: "Roles",
  //   to: "/admin/roles",
  //   icon: <CIcon icon={cibAddthis} customClassName="nav-icon" />,
  // },
  // {
  //   component: CNavItem,
  //   name: "Employee Management",
  //   to: "/admin/employeemanagement",
  //   icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
  // },
];

export default nav;
